import { render, staticRenderFns } from "./addpeople.vue?vue&type=template&id=29be6a4e&scoped=true"
import script from "./addpeople.vue?vue&type=script&lang=js"
export * from "./addpeople.vue?vue&type=script&lang=js"
import style0 from "./addpeople.vue?vue&type=style&index=0&id=29be6a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29be6a4e",
  null
  
)

export default component.exports